'use strict';

const orderInfoTemplate = require('../components/templates/orderInfo');
const checkCaptcha = require('../thirdParty/recaptcha/reCaptcha');

/**
 * Submit customer service ajax call
 * @param {JQuery} $form - current form
 * @param {Object} event - event
 * @param {string} options - additional options
 */
function submitCustomerServiceAjaxCall($form, event, options) {
    const url = $form.attr('action');
    const $responseContainer = $('.js-response-container');
    const $spinner = $form.spinner();
    const $customerServiceForm = $('.js-customer-service');

    options.formData.dwfrm_grecaptcha_response = options.captchaToken;

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: JSON.stringify(options.formData),
        contentType: 'application/json; charset=utf-8',
        success: function (data) {
            $spinner.stop();
            if (data.status === 'failed') {
                $responseContainer.empty().append(`
                    <h1>Sorry, an error occured</h1>
                    <p>${data.message} </p>
                `);
                $customerServiceForm.addClass('d-none');
            }

            if (data.status === 'info') {
                const orderInfoHTML = orderInfoTemplate(data);
                $responseContainer.removeClass('d-none').empty().append(orderInfoHTML);
                $form.find('#cs-support').prop('checked', true);
            }

            if (data.status === 'success') {
                //$('.js-introduction').empty().append('Your inquiry has been received. We sincerely appreciate your understanding as we tackle these new challenges together.');
                $('.js-response-success').removeClass('d-none');
                $customerServiceForm.addClass('d-none');
            }
        },
        error: function () {
            $spinner.stop();
            $customerServiceForm.addClass('d-none');
            $('.js-response-error').removeClass('d-none');
        }
    });
}

module.exports = {
    orderTypeSelect: function () {
        $('body').on('change', '.domestic-international-form', function () {
            const orderType = $(this).find('select').val();
            const $contactInfo = $('.js-international-contact-info');
            const $customerServiceForm = $('.js-customer-service');
            $('.js-response-container').empty();
            $('.js-response-success').addClass('d-none');
            $('.js-response-error').addClass('d-none');

            if (orderType === 'domestic') {
                $contactInfo.addClass('d-none');
                if ($('.js-response-place-order-reason').hasClass('d-none')) {
                    $customerServiceForm.removeClass('d-none');
                }
            } else if (orderType === 'international') {
                $contactInfo.removeClass('d-none');
                $customerServiceForm.addClass('d-none');
            } else {
                $contactInfo.addClass('d-none');
                $customerServiceForm.addClass('d-none');
            }
        });
    },

    reasonForContactSelect: function () {
        $('body').on('change', '.customer-service-form', function () {
            const $reasonForContact = $(this).find('select').val();
            $('.js-reason-for-contact').each((index, reason) => {
                const $reason = $(reason);
                if ($reason.val() === $reasonForContact) {
                    $('.js-show-purshase-location').toggleClass('d-none', !$reason.data('show-purchase-location'));
                }
            });
        });
    },

    submitCustomerServiceForm: function () {
        $('form.customer-service-form').on('submit', function (e) {
            e.preventDefault();
            const $form = $(this);
            const $spinner = $form.spinner();
            const $responsePlaceOrderReason = $('.js-response-place-order-reason');
            const $customerServiceForm = $('.js-customer-service');

            const formData = {
                firstName: $form.find('#cs-first-name').val(),
                lastName: $form.find('#cs-last-name').val(),
                emailAddress: $form.find('#cs-email-address').val(),
                orderNumber: $form.find('#cs-order-number').val(),
                reasons: $form.find('select#cs-reason-for-contact').val(),
                purchaseLocation: $form.find('select#cs-purchase-location').val(),
                notes: $form.find('#cs-notes').val(),
                support: $form.find('#cs-support').prop('checked')
            };

            if (formData.reasons === 'place_order') {
                $customerServiceForm.addClass('d-none');
                $responsePlaceOrderReason.removeClass('d-none');
            } else {
                $responsePlaceOrderReason.addClass('d-none');
                $spinner.start();

                checkCaptcha($form, null, submitCustomerServiceAjaxCall, { formData: formData });
            }
        });
    }
};
